import { showError } from '../../../../utils/errors';

import { COMPARISON_ITEM_TYPES } from '../../../../utils/constants';
import QuickSearchItem from '../../../../types/quick-search-item';
import { addFundToPortfolio, addStockToPortfolio, PortfolioActionProps } from './quick-search-portfolio-actions';

export function onAddItem(actions: PortfolioActionProps, item: QuickSearchItem) {
  const { _id: id, type } = item;

  switch (type) {
    case COMPARISON_ITEM_TYPES.FUND:
      return addFundToPortfolio(actions, id);
    case COMPARISON_ITEM_TYPES.STOCK:
      return addStockToPortfolio(actions, id);
    default:
      return showError;
  }
}
